document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.location-carousel-section').forEach(function (section) {
    new Swiper(section.querySelector('.location-carousel-slider'), {
      spaceBetween: 20,
      slidesPerView: 3,
      navigation: {
        nextEl: section.querySelector('.location-carousel-next'),
        prevEl: section.querySelector('.location-carousel-prev'),
        disabledClass: 'swiper-button-disabled',
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 20 },
        480: { slidesPerView: 1, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1068: { slidesPerView: 3, spaceBetween: 20 },
      }
    });

    const lightbox = section.querySelector('.location-carousel-lightbox');
    const slot = section.querySelector('.location-carousel-lightbox-slot');
    const closeBtn = section.querySelector('.location-carousel-lightbox-close');
    if (!lightbox || !slot || !closeBtn) return;

    function openLightbox(url) {
      slot.innerHTML = '';
      if (!url) {
        slot.innerHTML = '<div style="color:#fff;text-align:center;">No video configured</div>';
      } else {
        const video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('webkit-playsinline', 'true');
        video.style.objectFit = 'contain';
        video.style.objectPosition = 'center';
        slot.appendChild(video);
        video.play().catch(function () {});
      }
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      const vid = slot.querySelector('video');
      if (vid) { try { vid.pause(); } catch (e) {} vid.src = ''; }
      slot.innerHTML = '';
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }

    section.querySelectorAll('.location-carousel-thumbnail[data-video-url]').forEach(function (el) {
      const url = (el.getAttribute('data-video-url') || '').trim();
      if (!url) return;
      el.addEventListener('click', function () { openLightbox(url); });
    });

    closeBtn.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      const content = section.querySelector('.location-carousel-lightbox-content');
      if (content && !content.contains(e.target)) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.style.display === 'flex') closeLightbox();
    });
  });
});
